var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("line", {
      staticClass: "ls",
      attrs: { x1: "16.6", y1: "7.9", x2: "33.4", y2: "25" },
    }),
    _vm._v(" "),
    _c("line", {
      staticClass: "ls",
      attrs: { x1: "16.6", y1: "42.1", x2: "33.4", y2: "25" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }